import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import FaqSection from './FAQKeyword';
import FleetHighway from './FleetHighway';
import ContactShowcase from './phoneToWhatsApp';
import TestimonialSectionKeyword from './TestimonialSectionKeyword';

function Ertigacabbookinginpune() {



const cardData = {
  keyword: " Ertiga Cab Booking in Pune",

headingDescription: "Velocity Cab provides easy and affordable Ertiga cab booking in Pune, offering comfortable and spacious travel for families, groups, corporate clients, and leisure travelers. Our Maruti Suzuki Ertiga vehicles are well‑maintained, air‑conditioned, and designed to deliver smooth performance with ample seating and luggage space for long and short trips alike. Whether you need an Ertiga for local city travel, airport transfers, outstation journeys, or daily commuting, we offer flexible booking options with transparent pricing and no hidden charges. With professional drivers, prompt pickups, easy online booking, and 24/7 customer support, Velocity Cab is the trusted choice for Ertiga cab bookings in Pune.",

topPlaces: [
  
  {
    title: "Mahabaleshwar",
    description: "Mahabaleshwar is a renowned hill station near Pune celebrated for its strawberry farms, breathtaking viewpoints, and pleasant climate. Travelers booking a sedan cab can visit Venna Lake, Arthur’s Seat, Elephant’s Head Point, and Mapro Garden while enjoying scenic mountain roads. It is an excellent destination for families, couples, and nature enthusiasts."
  },
  {
    title: "Panchgani",
    description: "Panchgani is a charming hill station known for its rolling hills, Table Land, and colonial-era charm. Sedan cab travelers can explore scenic viewpoints, strawberry farms, and lush valleys while enjoying a comfortable outstation journey. The peaceful atmosphere makes it ideal for relaxation, sightseeing, and photography."
  },
  {
    title: "Lavasa",
    description: "Lavasa is a beautifully planned hill city near Pune offering colorful architecture, lakeside views, and adventure activities. Travelers using a sedan cab can enjoy a scenic drive through the Western Ghats, stroll along the waterfront promenade, and indulge in boating, cycling, and nature walks. It is a perfect destination for a refreshing day trip."
  },
  {
    title: "Lonavala",
    description: "Lonavala is one of the most popular hill stations near Pune, known for its lush green valleys, waterfalls, and scenic viewpoints. Travelers booking a sedan cab can enjoy a comfortable drive to explore attractions like Tiger Point, Bhushi Dam, Rajmachi Point, and Karla Caves. The pleasant weather and beautiful landscapes make it an ideal destination for weekend getaways and nature lovers."
  },
  {
    title: "Khandala",
    description: "Khandala is a picturesque hill station located close to Pune, famous for its misty hills, waterfalls, and panoramic viewpoints. Visitors using a sedan cab can enjoy a relaxing journey while exploring Duke’s Nose, Sunset Point, and Rajmachi Fort. The serene surroundings make it perfect for sightseeing, photography, and peaceful retreats."
  },
  {
    title: "Matheran",
    description: "Matheran is India's smallest hill station and is famous for its vehicle-free environment, dense forests, and stunning viewpoints. Sedan cab travelers can drive to Dasturi Point before exploring the hill station on foot or horseback. Popular attractions include Panorama Point, Echo Point, and Charlotte Lake."
  },
  {
    title: "Alibaug",
    description: "Alibaug is a popular coastal destination near Pune known for its sandy beaches, sea forts, and relaxed atmosphere. Travelers booking a sedan cab can visit Alibaug Beach, Kolaba Fort, Nagaon Beach, and Varsoli Beach while enjoying a comfortable road trip. It is ideal for beach lovers, families, and weekend vacations."
  },
  {
    title: "Bhimashankar",
    description: "Bhimashankar is a revered pilgrimage destination and wildlife sanctuary nestled in the Sahyadri hills. Travelers using a sedan cab can visit the famous Jyotirlinga temple, explore scenic trekking trails, and experience the rich biodiversity of the surrounding forest. The destination is perfect for spiritual seekers and nature lovers."
  },
  {
    title: "Kaas Plateau",
    description: "Kaas Plateau, also known as the Valley of Flowers of Maharashtra, is a UNESCO World Heritage Site famous for its seasonal bloom of colorful wildflowers. Sedan cab travelers can enjoy a scenic drive from Pune to witness the breathtaking floral landscape, making it an unforgettable destination for nature enthusiasts and photographers."
  },
  {
    title: "Raigad Fort",
    description: "Raigad Fort is one of Maharashtra’s most significant historical landmarks and the former capital of Chhatrapati Shivaji Maharaj. Travelers booking a sedan cab can enjoy a scenic drive to the fort, explore its grand gateways, royal palace ruins, and panoramic hilltop views. The destination offers a perfect blend of history, adventure, and breathtaking scenery."
  }
],



services: [
{
name: "Ertiga Rent per Km in Pune",
description: "Ertiga rent per km in Pune offers an affordable and flexible pricing model for travelers looking for a comfortable 6–7 seater vehicle. This option is ideal for families, small groups, and corporate travel where both space and budget matter. Transparent pricing includes per km charges, tolls, and driver allowance, ensuring no hidden costs. The Ertiga provides excellent mileage and smooth performance on highways, making it perfect for long-distance travel. Whether for local rides or outstation trips, this service ensures value for money with comfort. Easy booking options and professional drivers make it a reliable choice for Pune travelers."
},
{
name: "Ertiga Cab Booking in Pune",
description: "Ertiga cab booking in Pune provides a convenient way to reserve spacious and comfortable vehicles for city and outstation travel. Customers can book online with instant confirmation and flexible pickup options across Pune. This service is ideal for airport transfers, business trips, and family travel with ample seating and luggage space."
},
{
name: "Book Ertiga Car in Pune",
description: "Book Ertiga car in Pune easily for local and long-distance travel with professional drivers and well-maintained vehicles. This service ensures comfortable rides with smooth performance, making it suitable for both short and extended journeys."
},
{
name: "Pune to Outstation Ertiga Cab",
description: "Pune to outstation Ertiga cab service offers reliable travel to destinations like Mumbai, Mahabaleshwar, Nashik, and more. The spacious Ertiga is perfect for family trips and group travel with comfortable seating and luggage capacity."
},
{
name: "New Ertiga Cab Booking in Pune",
description: "New Ertiga cab booking in Pune offers upgraded vehicles with modern features, enhanced comfort, and improved safety. Customers can enjoy premium travel experience with clean and well-maintained cars."
},
{
name: "New Ertiga Cab Booking in Pune Contact Number",
description: "New Ertiga cab booking contact number in Pune helps customers quickly connect with reliable service providers for instant bookings. Easy communication ensures quick confirmations and smooth travel planning."
},
{
name: "New Ertiga Cab Booking in Pune Contact Number Hadapsar",
description: "Ertiga cab booking in Hadapsar Pune provides easy access to reliable taxi services for local and outstation travel. Customers can book spacious vehicles with professional drivers for comfortable journeys."
},
{
name: "Ertiga Cab Booking in Kharadi",
description: "Ertiga cab booking in Kharadi offers convenient travel for IT professionals and residents. This service ensures quick pickup from Kharadi offices, societies, and business hubs."
},
{
name: "Ertiga Cab Booking in Hinjewadi",
description: "Ertiga cab booking in Hinjewadi provides reliable travel for IT professionals and corporate employees. With flexible timings and comfortable vehicles, it is ideal for daily and outstation travel."
},
{
name: "Pune to Mahabaleshwar Ertiga Cab",
description: "Pune to Mahabaleshwar Ertiga cab service offers comfortable hill-station travel with spacious seating and smooth driving. The Ertiga is ideal for family trips with luggage and scenic travel."
},
{
name: "7 Seater Car on Rent in Pune",
description: "7 seater car on rent in Pune provides spacious travel options for families and small groups. Vehicles like Ertiga ensure comfort, safety, and smooth long-distance travel."
},
{
name: "8 Seater Car on Rent in Pune",
description: "8 seater car on rent in Pune offers larger vehicle options for group travel with additional seating capacity and comfort."
},
{
name: "Ertiga Cab Booking in Baner Aundh",
description: "Ertiga cab booking in Baner and Aundh offers reliable transportation for residents and professionals. This service ensures quick pickup and comfortable travel for city and outstation trips."
},
{
name: "Ertiga Car on Rent in Pune",
description: "Ertiga car on rent in Pune provides flexible rental options for local and intercity travel with professional drivers and comfortable vehicles."
},
{
name: "Pune Darshan Ertiga Cab Booking in Pune",
description: "Pune darshan Ertiga cab booking offers comfortable city tours covering popular attractions in Pune with spacious seating and convenient travel."
},
{
name: "Ertiga Cab Rentals in Pune",
description: "Ertiga cab rentals in Pune provide reliable and affordable transportation for local and outstation journeys with professional drivers."
},
{
name: "Cab for Outstation Journey",
description: "Cab for outstation journey service offers dependable long-distance travel from Pune to various destinations with comfortable vehicles and experienced drivers."
},
{
name: "Hire Ertiga Cab for Outstation",
description: "Hire Ertiga cab for outstation travel offers a perfect combination of space, comfort, and affordability for long-distance journeys."
},
{
name: "Velocity Cabs Ertiga Service",
description: "Velocity Cabs provides premium Ertiga cab services in Pune with reliable vehicles, experienced drivers, and affordable pricing for all travel needs."
},
{
name: "Ertiga Cab in Pune",
description: "Ertiga cab in Pune offers comfortable and spacious travel for families and groups with well-maintained vehicles and professional drivers."
},
{
name: "Ertiga on Rent in Pune",
description: "Ertiga on rent in Pune provides flexible travel options for local and outstation journeys with affordable pricing and reliable service."
},
{
name: "Ertiga Taxi Service Pune",
description: "Ertiga taxi service Pune ensures dependable transportation with comfortable seating and smooth travel experience for all types of trips."
},
{
name: "Maruti Ertiga Cab Hire Pune",
description: "Maruti Ertiga cab hire Pune offers high-quality travel with spacious interiors, reliable performance, and professional drivers ensuring safe journeys."
}
],

tableData: [
["Ertiga Rent per Km in Pune","Ertiga Cab Booking in Pune"],
["Book Ertiga Car in Pune","Pune to Outstation Ertiga Cab"],
["New Ertiga Cab Booking in Pune","New Ertiga Cab Booking in Pune Contact Number"],
["New Ertiga Cab Booking in Pune Contact Number Hadapsar","Ertiga Cab Booking in Kharadi"],
["Ertiga Cab Booking in Hinjewadi","Pune to Mahabaleshwar Ertiga Cab"],
["7 Seater Car on Rent in Pune","8 Seater Car on Rent in Pune"],
["Ertiga Cab Booking in Baner Aundh","Ertiga Car on Rent in Pune"],
["Pune Darshan Ertiga Cab Booking in Pune","Ertiga Cab Rentals in Pune"],
["Cab for Outstation Journey","Hire Ertiga Cab for Outstation"],
["Velocity Cabs Ertiga Service","Ertiga Cab in Pune"],
["Ertiga on Rent in Pune","Ertiga Taxi Service Pune"],
["Maruti Ertiga Cab Hire Pune","Ertiga Cab Booking in Pune"]
],




whychoose: [
  {
    WhyChooseheading: "Comfortable Ertiga Cab for Pune Travel",
    WhyChoosedescription: "Velocity Cabs offers spacious and comfortable Ertiga cab booking in Pune, ideal for families and small groups with ample seating and luggage space for city and outstation travel."
  },
  {
    WhyChooseheading: "Experienced Drivers",
    WhyChoosedescription: "Our drivers are experienced in Pune city routes and highways, ensuring safe driving, smooth journeys, and timely pickups and drop-offs for all customers."
  },
  {
    WhyChooseheading: "Transparent Cab Pricing",
    WhyChoosedescription: "Velocity Cabs provides transparent and affordable pricing for Ertiga cab bookings in Pune. Customers receive clear fare details including per km charges, toll charges, and driver allowance."
  },
  {
    WhyChooseheading: "24/7 Cab Booking Availability",
    WhyChoosedescription: "Our Ertiga cab service in Pune operates 24/7. Whether you need airport transfer, business travel, or late-night ride, Velocity Cabs ensures reliable service anytime."
  },
  {
    WhyChooseheading: "Clean & Sanitized AC Vehicles",
    WhyChoosedescription: "All Ertiga vehicles are fully air-conditioned, well maintained, and regularly sanitized to provide a safe and comfortable travel experience."
  },
  {
    WhyChooseheading: "Flexible Booking Options",
    WhyChoosedescription: "Velocity Cabs offers flexible booking options including local travel (8 hours/80 km), outstation trips, one-way travel, round-trip bookings, and customized packages."
  },
  {
    WhyChooseheading: "Ideal for Family & Group Travel",
    WhyChoosedescription: "Ertiga cabs are perfect for families, small groups, airport transfers, and business travel with comfortable seating for 5 to 6 passengers and luggage space."
  },
  {
    WhyChooseheading: "Trusted Cab Service in Pune",
    WhyChoosedescription: "Velocity Cabs is trusted by many customers for Ertiga cab booking in Pune due to professional drivers, clean vehicles, and reliable service."
  }
]
};

const faqData = [
  { question: "Do you provide Ertiga cab booking in Pune?", answer: "Yes, Velocity Cabs provides comfortable Ertiga cab booking services in Pune for local and outstation travel." },
  { question: "What is the price of Ertiga cab in Pune?", answer: "Ertiga cab pricing usually starts from ₹13 to ₹16 per km or ₹2000 to ₹3500 per day depending on the package." },
  { question: "How many passengers can travel in Ertiga?", answer: "Ertiga can comfortably accommodate 5 to 6 passengers along with luggage." },
  { question: "Is Ertiga available for airport transfers?", answer: "Yes, we provide airport pickup and drop services in Pune using Ertiga cabs." },
  { question: "Can I book Ertiga for outstation trips?", answer: "Yes, Ertiga cabs are available for outstation travel from Pune to destinations like Mumbai, Shirdi, Goa, and Mahabaleshwar." },
  { question: "Is cab service available 24 hours?", answer: "Yes, our Ertiga cab booking service in Pune operates 24/7." },
  { question: "Are vehicles air-conditioned?", answer: "Yes, all Ertiga vehicles are fully air-conditioned and well maintained." },
  { question: "Can I book Ertiga cab online?", answer: "Yes, customers can easily book Ertiga cab services in Pune online or through phone booking." },
  { question: "Is driver included in the booking?", answer: "Yes, all bookings include professional drivers for safe and comfortable travel." },
  { question: "Are vehicles sanitized regularly?", answer: "Yes, all vehicles are cleaned and sanitized regularly to ensure passenger safety and hygiene." }
];

const testimonials = [
  {
    id: 1,
    name: "Mr. Rajiv Deshmukh",
    feedback:
      "I booked an Ertiga cab in Pune with Velocity Cabs for a family outing, and the experience was excellent. The vehicle was spacious, clean, and very comfortable for long travel.",
    rating: 5
  },
  {
    id: 2,
    name: "Mrs. Sneha Patil",
    feedback:
      "The Ertiga cab service in Pune was very reliable and comfortable. The car was well-maintained, and the entire journey was smooth with a polite and professional driver.",
    rating: 5
  }
];





























const Images = [
  { place: "/images/keyword/1.jpg", text: "Pune to Mumbai Cab", link: "Pune-to-Mumbai-Cab" },
{ place: "/images/keyword/2.jpg", text: "Pune to Mumbai Airport Cabs", link: "Pune-to-Mumbai-Airport-Cabs" },
{ place: "/images/keyword/3.jpg", text: "Pune to Mumbai International Airport Cabs", link: "Pune-to-Mumbai-International-Airport-Cabs" },
{ place: "/images/keyword/4.jpg", text: "Pune to Mumbai One Way Cabs", link: "Pune-to-Mumbai-One-Way-Cabs" },
{ place: "/images/keyword/5.jpg", text: "Pune Mumbai Car Hire", link: "Pune-Mumbai-Car-Hire" },
{ place: "/images/keyword/6.jpg", text: "Pune to Mumbai Taxi Fare", link: "Pune-to-Mumbai-Taxi-Fare" },
{ place: "/images/keyword/7.jpg", text: "Pune to Mumbai Online Cab Booking", link: "Pune-to-Mumbai-Online-Cab-Booking" },
{ place: "/images/keyword/8.jpg", text: "Pimpri Chinchwad to Mumbai Cab", link: "Pimpri-Chinchwad-to-Mumbai-Cab" },
{ place: "/images/keyword/9.jpg", text: "Baner to Mumbai Cabs", link: "Baner-to-Mumbai-Cabs" },
{ place: "/images/keyword/10.jpg", text: "Hinjewadi to Mumbai Cabs", link: "Hinjewadi-to-Mumbai-Cabs" },
{ place: "/images/keyword/11.jpg", text: "Pimple Saudagar to Mumbai Cab Service", link: "Pimple-Saudagar-to-Mumbai-Cab-Service" },
{ place: "/images/keyword/12.jpg", text: "Wakad to Mumbai Cabs", link: "Wakad-to-Mumbai-Cabs" },
{ place: "/images/keyword/13.jpg", text: "Hadapsar to Mumbai Cabs", link: "Hadapsar-to-Mumbai-Cabs" },
{ place: "/images/keyword/14.jpg", text: "Kalyani Nagar to Mumbai Taxi", link: "Kalyani-Nagar-to-Mumbai-Taxi" },
{ place: "/images/keyword/15.jpg", text: "Koregaon Park to Mumbai Cabs", link: "Koregaon-Park-to-Mumbai-Cabs" },
{ place: "/images/keyword/16.jpg", text: "Kothrud to Mumbai Cabs", link: "Kothrud-to-Mumbai-Cabs" },
{ place: "/images/keyword/17.jpg", text: "Kharadi to Mumbai Cabs", link: "Kharadi-to-Mumbai-Cabs" },
{ place: "/images/keyword/18.jpg", text: "Shivajinagar to Mumbai Cabs", link: "Shivajinagar-to-Mumbai-Cabs" },
{ place: "/images/keyword/19.jpg", text: "Pune to Mumbai Ertiga Cab", link: "Pune-to-Mumbai-Ertiga-Cab" },
{ place: "/images/keyword/20.jpg", text: "Pune to Mumbai Innova Crysta Cabs", link: "Pune-to-Mumbai-Innova-Crysta-Cabs" },
{ place: "/images/keyword/21.jpg", text: "Pune to Mumbai Sedan Cab", link: "Pune-to-Mumbai-Sedan-Cab" },
{ place: "/images/keyword/22.jpg", text: "Kondhwa to Mumbai Cabs", link: "Kondhwa-to-Mumbai-Cabs" },
{ place: "/images/keyword/23.jpg", text: "Viman Nagar to Mumbai Cabs", link: "Viman-Nagar-to-Mumbai-Cabs" },
{ place: "/images/keyword/24.jpg", text: "Katraj to Mumbai Cab Service", link: "Katraj-to-Mumbai-Cab-Service" },
{ place: "/images/keyword/25.jpg", text: "Pune Station to Mumbai Cabs Service", link: "Pune-Station-to-Mumbai-Cabs-Service" },
];











const puneErtigaCabJSON = {
  "@context": "https://schema.org",
  "@type": "Service",
  "name": "Ertiga Cab Booking in Pune | Velocity Cabs",
  "description": "Book an Ertiga cab in Pune with Velocity Cabs. Affordable per km rates, outstation trips, airport transfers, and one-way or round-trip options available.",
  "provider": {
    "@type": "Organization",
    "name": "Velocity Cabs",
    "url": "https://www.velocitycabs.com/"
  },
  "areaServed": {
    "@type": "Place",
    "name": "Pune, Maharashtra, India"
  },
  "serviceType": [
    "Ertiga Cab Booking Pune",
    "Pune to Outstation Ertiga Cab",
    "Ertiga Airport Cab Pune",
    "One Way Ertiga Cab Pune",
    "Round Trip Ertiga Cab Pune"
  ],
  "offers": {
    "@type": "Offer",
    "url": "https://www.velocitycabs.com/",
    "priceCurrency": "INR",
    "availability": "https://schema.org/InStock"
  }
};







  return (
    <div>
      <Helmet>
  <title>Ertiga Cab Booking in Pune | Velocity Cabs +91 9136271336</title>
  <meta
    name="description"
    content="Book an Ertiga cab in Pune with Velocity Cabs. Per km rates, airport transfers, outstation trips, one-way and round trips available. Safe and reliable service."
  />
  <script type="application/ld+json">
    {JSON.stringify(puneErtigaCabJSON)}
  </script>
</Helmet>


 <div className="breadcrumb-bar">
      <div className="container">
        <div className="row align-items-center text-center">
          <div className="col-md-12 col-12">
            <h2 className="breadcrumb-title"> {cardData.keyword}</h2>
           
          </div>
        </div>
      </div>
    </div>




      








      <section>
        <div className="container-fluid" >
          <div className="row container-fluid">
            <div className="col-12 col-md-7 bg-foootr">
              <img src='/images/keyword/70.jpg' alt='img' className='img-fluid' />
              <h3 className="py-1"
                style={{
                  color: '#183765', // Red color for the title 
                  textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                  fontWeight: 'bold'
                }}


              >Velocity Cabs: {cardData.keyword} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
              <div className="topPlaces">
                {/* <p className="sectionLead">{cardData.top}</p> */}
              
     <p className="sectionLead">Top Places to visit from {cardData.keyword} </p>
                {cardData.topPlaces.map((place, index) => (
                  <article key={index} className="placeCard borderr" tabIndex="0">
                    <span className="placeBadge">{String(index + 1).padStart(2, "0")}</span>

                    <div className="placeBody">
                      <h4 className="placeTitle">{place.title}</h4>
                      <p className="placeDesc">{place.description}</p>
                  
                    </div>

                    <span className="placeArrow" aria-hidden>›</span>
                  </article>
                ))}
              </div>

              
              <div className="services-section">
                {cardData.services.map((service, index) => (
                  <div key={index} className="service-row">
                    <div className="service-icon">
                      🚗
                    </div>
                    <div>
                      <h4 className="service-title">{service.name}</h4>
                      <p className="service-desc">{service.description}</p>
                    </div>
                  </div>
                ))}
              </div>


              <table className="table table-responsive Border-key my-2">
                <tbody className=' Border-key'>
                  {cardData.tableData.map((row, rowIndex) => (
                    <tr className='Border-key ' key={rowIndex}>
                      {row.map((cell, cellIndex) => (
                        <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                      ))}
                    </tr>
                  ))}
                </tbody>
              </table>
              <h3 className='pt-md-3'>{cardData.keyword + " Rates"}</h3>
              <BusRatesTable />

              <div id="why-choose-section" className="why-choose-section">


                {/* Section Title */}
                <h2 className="section-title">
                  Why Choose <span>Velocity Cab</span>
                </h2>

                {/* Cards */}
                <div className="cards-grid">
                  {cardData.whychoose.map((item, index) => (
                    <div key={index} className="why-card">
                      <div className="icon-circle">{index + 1}</div>
                      <h4 className="card-heading">{item.WhyChooseheading}</h4>
                      <p className="card-desc">{item.WhyChoosedescription}</p>
                    </div>
                  ))}
                </div>
              </div>



              <div className="row twm-faq-section-1 m-b30">


                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                  <div className="twm-faq-info-wrap">

                    <div className="section-head left">
                      <h2 className="twm-large-title site-text-dark">FAQS {cardData.keyword} For Velocity Cab </h2>
                    </div>


                    <div className="twm-faq-info">
                      <div className="accordion twm-acdn" id="sf-faq-accordion">

                        <FaqSection
                          title="Frequently Asked"
                          subtitle="Help & Info"
                          items={faqData}
                        />

                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <TestimonialSectionKeyword
                testimonials={testimonials}
              />


               <ContactShowcase keyword={cardData.keyword} />
            </div>

            <div className='col-12 col-md-4' >
              <div className="routeList">
                {Images.map((e, i) => {
                  const isExternal = typeof e.link === "string" && /^https?:\/\//i.test(e.link);
                  const href = isExternal ? e.link : `/${String(e.link || "").replace(/^\/+/, "")}`;

                  return (
                    <a
                      key={e.link || i}
                      href={href}
                      className="routeItem"
                      aria-label={e.text}
                      {...(isExternal ? { target: "_blank", rel: "noopener noreferrer" } : {})}
                    >
                      <div className="routeThumb">
                        <img src={e.place} alt="" loading="lazy" />
                      </div>

                      <div className="routeMeta">
                        <h6 className="routeTitle">{e.text}</h6>
                        <span className="routeUnderline" />
                      </div>

                      <span className="routeArrow" aria-hidden>›</span>
                    </a>
                  );
                })}
              </div>




              <div>
                <FleetHighway />
              </div>
              <div className="pc-contact">
  <h4 className="pc-title">Contact Information</h4>

  <div className="pc-grid">
    {/* Phones */}
    <section className="pc-tile">
      <header className="pc-tile-head">
        <i className="bi bi-telephone-fill"></i>
        <span>Phone Numbers</span>
      </header>

      <div className="pc-list">
        <a href="tel:+919136271336" className="pc-call">+91 9136271336</a>
      </div>

      <div className="pc-cta">
        <a
          href="https://wa.me/919136271336"
          target="_blank"
          rel="noopener noreferrer"
          className="pc-whats"
        >
          <i className="bi bi-whatsapp"></i> WhatsApp
        </a>
        <a href="tel:+919136271336" className="pc-primary">
          Call Now
        </a>
      </div>
    </section>

    {/* Email */}
    <section className="pc-tile">
      <header className="pc-tile-head">
        <i className="bi bi-envelope-fill"></i>
        <span>Email</span>
      </header>

      <a href="mailto:booking@velocitycabs.com" className="pc-email">
        booking@velocitycabs.com
      </a>
    </section>

    {/* Address */}
    <section className="pc-tile">
      <header className="pc-tile-head">
        <i className="bi bi-geo-alt-fill"></i>
        <span>Address</span>
      </header>

      <address className="pc-address">
        <strong>Velocity Cab</strong><br />
        Prakash Residency, Sec 10E, Plot 40 Roadpali, Kalamboli 410218 Navi Mumbai, Maharashtra
      </address>
    </section>
  </div>
</div>


            </div>
          </div>
        </div>
      </section>


    </div>
  );
}

export default Ertigacabbookinginpune;